import React from 'react'
import CardInfo from '../../../components/CardInfo/CardInfo'
import PropTypes from 'prop-types'
import ButtonWithTooltip from '../../../components/ButtonWithTooltip/ButtonWithTooltip'
import EditIcon from '../../../svg/EditIcon'
import useIntercom from '../../../hooks/useIntercom'
import MapLocation from './MapLocation'
import { useNetworkStatus } from '../../../utils/networkStatus'

const AssetLocation = ({ location, address, assetEquipment, cords }) => {
    const { intercomSendMessage } = useIntercom()
    const { isOffline } = useNetworkStatus()

    const renderContentLocation = () => {
        return (
            <div className="w-full h-full flex flex-col items-start justify-start md:gap-y-6 gap-y-4">
                {isOffline ? (
                    <div className="w-full h-full bg-gray-200 rounded-xl flex items-center justify-center">
                        <p className="text-sm text-gray-600">
                            No location available
                        </p>
                    </div>
                ) : (
                    <>
                        {cords && <MapLocation location={cords} />}

                        <div className="flex flex-col items-start justify-start">
                            <p className="text-textDarkerGray text-base font-normal">
                                {location}
                            </p>
                            <p className="text-textDarkGray text-sm font-normal">
                                {address}
                            </p>
                        </div>
                    </>
                )}
            </div>
        )
    }

    const onChangeLocation = () => {
        const message =
            'I want to change the location for asset: ' + assetEquipment
        intercomSendMessage(message)
    }

    return (
        <CardInfo
            title="Asset Location"
            content={renderContentLocation()}
            headerActions={[
                <div
                    key="headerActionDiv"
                    className="h-10 max-h-full relative flex items-center justify-end w-auto"
                >
                    <ButtonWithTooltip
                        onClick={onChangeLocation}
                        type="button"
                        key="deleteAsset"
                        variant="tertiary"
                        className="rounded-lg p-0 w-10 h-10"
                        icon={
                            <div className="text-textDarkerGray stroke-current stroke-2 w-5 h-5">
                                <EditIcon />
                            </div>
                        }
                        disabled={isOffline}
                        isOffline={isOffline}
                        position="left"
                    />
                </div>,
            ]}
        />
    )
}

AssetLocation.propTypes = {
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
    address: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
    assetEquipment: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
    cords: PropTypes.oneOfType([PropTypes.object, PropTypes.any]),
}

export default AssetLocation
